<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-11-28 10:35:45
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
  },
};
</script>
